import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {GetUser} from '../actions/index';
import Breadcrumbs from 'react-breadcrumbs';
import { IndexRoute, Router, Route, Link } from 'react-router';

class Header extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.Logout = this.Logout.bind(this);

        let token = localStorage.getItem('id_token_admin');
        this.props.GetUser(token).then((response) => {
            if (response.payload.status !== 200) {
                delete localStorage.id_token_admin;
                return this.context.router.push('/sign_in');
            }
        });
    }
    Logout(){
        delete localStorage.id_token_admin;
        this.context.router.push('/sign_in');
    }
    render() {
        return (
            <div className="header clearfix">
                <div className="breadcrumb-wrapper">
                    <Breadcrumbs routes={this.props.routes} setDocumentTitle={true}/>
                </div>
                <div className="header-user">
                    <div className="header-user-log-out">
                            <span onClick={this.Logout} className="glyphicon glyphicon-log-out"
                                  aria-hidden="true"></span>
                    </div>
                    <div className="header-user-name">
                        <div className="pull-left">
                            <span className="glyphicon glyphicon-user" aria-hidden="true"></span>
                        </div>
                        <p className="pull-left">{this.props.user.user_detail ? this.props.user.user_detail.email : ''}</p>
                    </div>
                </div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        user: state.user,
        routerState : state.router
    }
}

export default connect(mapStateToProps, {GetUser})(Header);



// WEBPACK FOOTER //
// ./src/components/header.js